export const aiAgent = {
  head: {
    chip: "Recepção IA",
    listingLabel: "Anúncio:",
  },
  globalNote: {
    title: "Configurações para toda a conta",
    body: "Aplica-se a <b>TODAS as suas propriedades</b>. O Agente IA atende qualquer pessoa que escreva pela primeira vez para o seu <b>número de WhatsApp conectado</b> que <b>ainda não é cliente e não tem reserva</b>: responde às suas perguntas e a orienta até a reserva.",
  },
  perListingNote: {
    title: "Configurado por anúncio",
    body: "A emissão de faturas usa o <b>emissor de faturamento</b> vinculado a cada anúncio, por isso é ativada e ajustada nas configurações de cada anúncio (não globalmente). Abra um anúncio e vá em «Emissão de faturas».",
  },
  noEmisor: {
    title: "Este anúncio não tem emissor de faturamento",
    body: "A emissão de faturas não pode ser ativada até que você vincule um emissor a este anúncio em <b>Minha conta → Faturamento eletrônico</b>. Cada emissor é atribuído a um anúncio.",
  },
  master: {
    requiresEmisor: "Requer um emissor de faturamento",
    on: "Ativado",
    off: "Desativado",
  },
  cartelQr: {
    title: "Cartaz de check-in para a receção",
    hint: "Imprima-o e deixe-o no balcão: o hóspede digitaliza, escreve o número da reserva e faz o check-in pelo telemóvel. Útil quando a OTA não envia todos os dados.",
    steps: "O hóspede digitaliza · escreve o número da reserva · completa os seus dados.",
    download: "Descarregar cartaz (PDF)",
    downloading: "A preparar…",
    downloadError: "Não foi possível preparar o cartaz.",
    copy: "Copiar link",
    copied: "Link copiado",
    language: "Idioma do cartaz",
    alsoEnglish: "Adicionar inglês por baixo",

    copyManual: "Não foi possível copiar. Seleciona o link e copia-o à mão.",
    popupBlocked: "O navegador bloqueou a janela. Copia o link e abre-o noutro separador.",
    loadError: "Não foi possível carregar o cartaz.",
    retry: "Tentar de novo",  },
  checkinSchedule: {
    title: "Quando começa o check-in?",
    hint: "Programe quando o agente envia o link de check-in ao hóspede. Aplica-se no nível do anúncio.",
  },
  avisoCheckin: {
    title: "Avisar por email ao concluir o check-in",
    hint: "Quando o grupo termina o registo, enviamos o resumo da reserva — titular, acompanhantes e documentos — com a ficha assinada em anexo. Útil para a portaria ou a receção.",
    enable: "Enviar o aviso",
    steps: "Enviado uma só vez, quando se regista a última pessoa do grupo.",
    placeholder: "portaria@teualojamento.com",
    add: "Adicionar email",
    remove: "Remover",
    max: "No máximo {n} emails.",
    save: "Guardar",
    saving: "A guardar…",
    saved: "Aviso guardado",
    saveError: "Não foi possível guardar.",
    badEmail: "«{email}» não é um endereço válido.",
    needOne: "Adiciona pelo menos um email para ativar o aviso.",
  },
  field: {
    optional: "(opcional)",
    yes: "Sim",
    no: "Não",
  },
  variant: {
    nationality: "Nacionalidade",
    writingStyle: "Estilo de escrita",
  },
  robot: {
    title: "O que o agente sabe",
  },
  pdf: {
    loaded: "Documento enviado · o agente lerá o seu conteúdo",
    remove: "Remover",
    replace: "Substituir PDF",
    dropTitle: "Envie um arquivo PDF ou Word com o guia da propriedade",
    dropHint: "PDF ou .docx · máx. 15 MB",
  },
  payments: {
    required: "Requer conectar uma plataforma de pagamento",
    connect: "Conectar uma plataforma de pagamento →",
  },
  faq: {
    qPlaceholder: "Pergunta · ex.: Tem estacionamento?",
    aPlaceholder: "Resposta · ex.: Sim, gratuito na porta.",
  },
  list: {
    remove: "Remover",
    add: "Adicionar",
  },
  footer: {
    saved: "Salvo",
    save: "Salvar alterações",
  },
  wa: {
    online: "online",
    caption: "Prévia · atualiza com as suas configurações",
    defaultName: "Recepção IA",
  },
  errors: {
    pdfType: "O arquivo deve ser um PDF ou um Word (.docx).",
    pdfSize: "O arquivo excede 15 MB.",
    pdfNoText: "Não conseguimos ler nenhum texto do documento (é um PDF digitalizado ou vazio?). Tente outro ou use texto livre.",
    pdfUpload: "Não foi possível enviar o PDF.",
    pdfRemove: "Não foi possível remover o PDF.",
    loadConfig: "Não foi possível carregar as configurações.",
    saveConfig: "Não foi possível salvar. Tente novamente.",
  },
  features: {
    general: {
      title: "Configurações gerais",
      subtitle: "Defina a identidade e o estilo do agente. Esta é uma configuração de CONTA: aplica-se a TODAS as suas propriedades.",
      sections: {
        identity: {
          label: "Identidade do agente",
          hint: "Como ele se apresenta e em que estilo responde.",
        },
      },
      fields: {
        agentName: {
          label: "Nome do agente",
          placeholder: "ex.: Sofía, Recepção Loft Ámbar…",
        },
        persona: {
          label: "Personalidade",
          options: {
            amigable: "Amigável e acolhedor",
            profesional: "Profissional e prestativo",
            eficiente: "Direto e eficiente",
            entusiasta: "Entusiasmado e acolhedor",
            sereno: "Calmo e tranquilo",
          },
        },
        tone: {
          label: "Tom da resposta",
          options: {
            cercano: "Descontraído",
            cordial: "Cordial",
            formal: "Formal",
            profesional: "Profissional",
          },
        },
        responseLength: {
          label: "Tamanho da resposta",
          options: {
            brief: "Breve (1-2 frases)",
            balanced: "Equilibrado",
            detailed: "Detalhado",
          },
        },
        useEmojis: {
          label: "Usar emojis",
        },
        language: {
          label: "Idioma principal",
          options: {
            auto: "Automático (com base no hóspede)",
            es: "Espanhol",
            en: "Inglês",
            fr: "Francês",
            de: "Alemão",
            pt: "Português",
            it: "Italiano",
          },
        },
        spanishVariant: {
          label: "Estilo de escrita (Espanhol)",
        },
        signature: {
          label: "Assinatura de despedida",
          placeholder: "ex.: — A equipe Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Base de conhecimento",
      subtitle: "Tudo o que o Agente IA precisa saber para atender os seus hóspedes com precisão.",
      enableLabel: "O agente usa esta base de conhecimento",
      sections: {
        knowledge: {
          label: "Conhecimento da propriedade",
          hint: "Escolha como você fornece as informações que o agente vai usar.",
        },
        behavior: {
          label: "Comportamento e limites",
          hint: "Defina as regras do agente e quando pedir ajuda humana.",
        },
      },
      fields: {
        kbMode: {
          label: "Como você quer fornecer as informações?",
          options: {
            form: "Formulários",
            text: "Texto livre",
            pdf: "Enviar um documento",
          },
        },
        propertyType: {
          label: "Tipo de propriedade",
          options: {
            apartment: "Apartamento",
            house: "Casa",
            villa: "Villa",
            loft: "Loft",
            room: "Quarto",
            cabin: "Cabana",
            hotel: "Hotel",
            hostel: "Hostel",
          },
        },
        kbText: {
          label: "Informações da propriedade",
          placeholder: "Escreva ou cole aqui TUDO o que o agente deve saber: WiFi e senha, estacionamento, eletrodomésticos, aquecimento/ar-condicionado, regras da casa, recomendações locais…",
          hint: "O agente usará este texto tal como está para responder.",
        },
        kbPdf: {
          label: "Documento da propriedade",
          hint: "Envie o guia da propriedade como PDF ou Word (.docx). O agente lerá o seu conteúdo para responder.",
        },
        description: {
          label: "Informações gerais",
          placeholder: "Como funcionam o aquecimento e o ar-condicionado, eletrodomésticos, controle de temperatura, particularidades da propriedade…",
          hint: "Contexto principal que o agente usará em cada resposta.",
        },
        wifiName: {
          label: "Nome do WiFi",
          placeholder: "MyWifi_5G",
        },
        wifiPassword: {
          label: "Senha do WiFi",
        },
        parkingInfo: {
          label: "Estacionamento",
          placeholder: "Estacionamento gratuito na porta / Estacionamento pago a 100m / Sem estacionamento…",
        },
        amenities: {
          label: "Comodidades e equipamentos",
          placeholder: "Cozinha equipada, máquina de lavar, secadora, ar-condicionado, elevador, berço, toalhas…",
        },
        houseRules: {
          label: "Regras da casa",
          placeholder: "Proibido fumar, sem festas, sem animais, horário de silêncio 22:00–08:00…",
        },
        localRecommendations: {
          label: "Recomendações locais",
          placeholder: "Restaurantes, supermercados, transporte, o que visitar por perto…",
        },
        faqs: {
          label: "Perguntas frequentes",
          hint: "Pares de pergunta e resposta. Você pode anexar imagens ou vídeos a cada um.",
        },
        links: {
          label: "Links e documentos",
          itemPlaceholder: "https://… (guia da casa, manual, mapa)",
          hint: "Recursos externos que o agente pode consultar.",
        },
        sendAmenityPhotos: {
          label: "Enviar fotos dos equipamentos e comodidades",
          hint: "Se o hóspede perguntar por uma comodidade que tenha fotos, o agente responde e as envia. Se não tiver, responde só com texto.",
        },
        customInstructions: {
          label: "Instruções personalizadas",
          placeholder: "Regras específicas de tom ou conteúdo. Ex.: sempre oferecer late checkout se perguntarem sobre a saída.",
        },
        forbiddenTopics: {
          label: "Tópicos ou ações proibidos",
          placeholder: "Ex.: não dar descontos, não confirmar mudanças de datas sem aprovação, não compartilhar dados de outros hóspedes.",
        },
        escalationRules: {
          label: "Quando transferir para um humano",
          placeholder: "Ex.: se houver uma avaria, uma reclamação grave ou um pedido de reembolso, transferir para o anfitrião.",
        },
        fallbackMessage: {
          label: "Mensagem quando não sabe a resposta",
          placeholder: "Não tenho esse detalhe à mão, mas vou avisar o anfitrião e retornaremos para você imediatamente 🙌",
        },
        humanContact: {
          label: "Contato do anfitrião",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Horário de atendimento humano",
          placeholder: "Seg–Dom 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Gerenciar o check-in automaticamente",
    },
    newBookings: {
      title: "Novas reservas e leads",
      subtitle: "O agente atende novos leads (pessoas que escrevem pela primeira vez e querem reservar ou têm dúvidas) e envia a eles o link de Reserva Direta para que concluam a reserva na web. Esta é uma configuração de CONTA: aplica-se a todas as suas propriedades.",
      enableLabel: "Atender leads e pedidos de reserva",
      sections: {
        businessIdentity: {
          label: "Identidade do negócio",
          hint: "O nome com o qual o agente se apresenta a quem ainda não reservou.",
        },
        newLeads: {
          label: "Novos leads · primeiro contato",
          hint: "Como ele atende alguém que escreve pela primeira vez, está interessado e ainda não reservou.",
        },
        bookingLink: {
          label: "Link de reserva",
        },
      },
      fields: {
        businessName: {
          label: "Nome do negócio",
          placeholder: "ex.: Hostel Elios, Apartamentos del Puerto, Grupo Ámbar…",
          hint: "Quando alguém sem reserva pergunta quem é você, o agente responde «Sou o assistente de [este nome]». Se você deixar em branco, ele se apresenta de forma genérica, sem dizer de qual negócio é.",
        },
        leadWelcomeMessage: {
          label: "Mensagem de boas-vindas para um novo lead",
          placeholder: "Olá! 👋 Sou o assistente da propriedade. Está procurando datas para uma escapada ou tem alguma dúvida? Fico feliz em ajudar 😊",
          hint: "Saudação de primeiro contato quando alguém escreve pela primeira vez. Não se repete nas mensagens seguintes.",
        },
        leadWelcomeVerbatim: {
          label: "Enviar a saudação tal como está (sem adaptá-la)",
          hint: "Ativado: o agente usa a sua mensagem palavra por palavra no primeiro contato. Desativado: ele a adapta ao tom da conversa.",
        },
        answerKbForLeads: {
          label: "Responder perguntas mesmo antes de terem reservado",
          hint: "O agente responde às perguntas gerais com a base de conhecimento —mesmo que ainda não seja um hóspede— e também pode enviar a ele o link de reserva.",
        },
        proactiveOffer: {
          label: "Sugerir a reserva de forma proativa",
          hint: "Mesmo que o lead pergunte sobre outras coisas, o agente o incentiva a reservar e envia o link quando apropriado, sem insistir.",
        },
        offerMessage: {
          label: "Mensagem ao oferecer a reserva",
          placeholder: "Claro! Você pode reservar diretamente aqui 👇 Vou te enviar o link para escolher as suas datas.",
          hint: "O tom que o agente usa ao oferecer a reserva. O agente adiciona o link automaticamente.",
        },
      },
    },
    earlyAccess: {
      title: "Gestão do horário de chegada",
      subtitle: "O agente gerencia os pedidos de check-in antecipado: registra o horário de chegada que o hóspede solicita e o trata de acordo com as suas regras.",
      enableLabel: "Gerenciar horários de chegada",
      sections: {
        request: {
          label: "Tratamento de pedidos",
          hint: "Como o agente responde com base no horário solicitado. Se você desativar isso, o pedido fica pendente para você escolher (Aprovar / Aprovar outro horário / Priorizar / Rejeitar).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Responder «sujeito à disponibilidade» se for antes do check-in",
          hint: "O agente diz ao hóspede que você vai tentar; fica pendente da sua confirmação.",
        },
        autoApproveLate: {
          label: "Aprovar automaticamente se for depois do check-in",
          hint: "Uma chegada dentro do horário normal é confirmada automaticamente.",
        },
      },
    },
    lateCheckout: {
      title: "Late checkout",
      subtitle: "O agente gerencia os pedidos de late checkout: valida o horário, informa o preço e registra o pedido.",
      enableLabel: "Gerenciar late checkout",
      sections: {
        availability: {
          label: "Disponibilidade e horários",
        },
        extraPrice: {
          label: "Preço da hora extra",
          hint: "Apenas a parte após as horas de cortesia é cobrada.",
        },
        messages: {
          label: "Mensagens",
        },
      },
      fields: {
        standardCheckout: {
          label: "Horário de checkout padrão",
        },
        courtesyHours: {
          label: "Horas de cortesia (grátis)",
          unit: "h",
          hint: "Horas após o checkout padrão que NUNCA são cobradas.",
        },
        latestTime: {
          label: "Horário máximo de checkout",
          hint: "Limite absoluto. Além do período de cortesia, as horas extras são cobradas.",
        },
        subjectToAvailability: {
          label: "Sujeito à disponibilidade",
          hint: "As horas extras só são oferecidas se nenhuma outra reserva chegar naquele dia.",
        },
        autoConfirm: {
          label: "Confirmar automaticamente se o hóspede aceitar",
          hint: "Aplica-se apenas às horas grátis.",
        },
        pricingModel: {
          label: "Modelo de preço",
          options: {
            fixed: "Preço fixo",
            perHour: "Por hora extra",
          },
        },
        price: {
          label: "Valor",
          hint: "Preço fixo ou tarifa por hora extra além do período de cortesia.",
        },
        freeIfAvailable: {
          label: "Grátis se não houver chegada no mesmo dia",
          hint: "Se aquele dia estiver livre, as horas extras também não são cobradas.",
        },
        paymentMethods: {
          label: "Formas de pagamento para as horas extras",
          options: {
            online: "Pagamento online (Stripe) — o agente envia um link",
            cash: "Dinheiro no checkout",
          },
          hint: "Você pode oferecer uma ou ambas. O agente informará o hóspede.",
        },
        offerMessage: {
          label: "Mensagem de oferta",
          placeholder: "Precisa de mais tempo? Podemos oferecer checkout até as 13:00.",
        },
        confirmationMessage: {
          label: "Mensagem de confirmação",
          placeholder: "Pronto! Seu late checkout está confirmado. Aproveite essas horas extras 🙌",
        },
      },
    },
    invoicing: {
      title: "Emissão de faturas",
      subtitle: "O agente envia ao hóspede um link para preencher os seus dados fiscais e baixar a sua fatura eletrônica, usando o emissor de faturamento vinculado a este anúncio.",
      enableLabel: "Gerenciar pedidos de fatura",
      sections: {
        whenSend: {
          label: "Quando o link da fatura é enviado?",
          hint: "Escolha como o link chega ao hóspede. As opções do modo que você escolher aparecem abaixo.",
        },
        requirements: {
          label: "Requisitos para enviá-lo instantaneamente",
          hint: "O agente só entrega o link a hóspedes que já concluíram o check-in e pagaram a reserva integralmente; assim que preenchem os seus dados, a fatura é emitida e baixada instantaneamente. Para reservas de OTA (Booking/Airbnb), a fatura só pode ser recebida quando o serviço já começou (a estadia começou) e o pagamento está concluído.",
        },
        manualReview: {
          label: "Revisão manual",
          hint: "Apenas o pedido do hóspede é registrado e fica pendente em «Faturas aguardando envio» para você emitir manualmente. Nenhuma fatura é gerada automaticamente, e não importa quando eles pedem nem se a reserva está paga (você revisa).",
        },
        fiscalData: {
          label: "Dados fiscais do emissor",
          hint: "Os dados fiscais (razão social, identificação fiscal, série, VAT, Verifactu) NÃO são configurados aqui: são obtidos do emissor de faturamento vinculado a este anúncio em Minha conta → Faturamento eletrônico.",
        },
        sendToGuest: {
          label: "Envio ao hóspede",
        },
      },
      modes: {
        after_checkout: {
          label: "Apenas sob solicitação",
          desc: "O concierge de IA responde quando o hóspede pede a sua fatura.",
        },
        always_after_checkout: {
          label: "Sempre, quando a estadia termina",
          desc: "Para todos que concluíram o check-in, quer peçam ou não. Recomendado.",
        },
      },
      cards: {
        on_request: {
          label: "Assim que pedirem",
          desc: "Eles recebem o link imediatamente, se atenderem aos requisitos.",
        },
        after_checkout: {
          label: "Quando a estadia termina",
          desc: "O pedido é salvo e o link chega a eles após o checkout.",
        },
        manual: {
          label: "Apenas registrar",
          desc: "Fica pendente e você emite manualmente.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Emitir a fatura mesmo que não preencham o formulário",
          hint: "É emitida com os dados do check-in e o PDF é enviado a eles por e-mail e WhatsApp. Uma fatura emitida não pode ser editada.",
        },
        autoIssueAfterHours: {
          label: "Quanto tempo esperar antes de emiti-la",
          options: {
            h24: "24 horas após o envio do link",
            h48: "48 horas após o envio do link",
            h72: "72 horas após o envio do link",
          },
        },
        manualSendLink: {
          label: "Enviar ao hóspede o link para preencher os seus dados fiscais",
          hint: "Se você ativar, o agente envia o link para que o hóspede possa fornecer os seus dados com antecedência. A fatura ainda é emitida manualmente.",
        },
        sendToGuest: {
          label: "Enviar o link ao hóspede por",
          options: {
            email: "E-mail",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Estender a estadia",
      subtitle: "O agente gerencia os pedidos para adicionar noites: verifica a disponibilidade, informa o preço e registra o pedido.",
      enableLabel: "Permitir pedidos para estender a estadia",
      sections: {
        availability: {
          label: "Disponibilidade",
          hint: "O número máximo de noites é definido automaticamente pela próxima reserva no calendário.",
        },
        price: {
          label: "Preço",
        },
        messages: {
          label: "Mensagens",
        },
      },
      fields: {
        autoConfirm: {
          label: "Estender a reserva automaticamente na confirmação",
          hint: "Se você desativar isso, permanece um pedido para você aprovar.",
        },
        useListingRate: {
          label: "Usar a tarifa por noite do anúncio",
          hint: "Calcula a tarifa a partir do preço da reserva.",
        },
        pricePerNight: {
          label: "Preço por noite adicional",
          hint: "Somente se você não usar a tarifa do anúncio.",
        },
        paymentMethods: {
          label: "Formas de pagamento para as noites extras",
          options: {
            online: "Pagamento online (Stripe) — o agente envia um link",
            cash: "Dinheiro",
          },
        },
        offerMessage: {
          label: "Mensagem de oferta",
          placeholder: "Quer ficar mais tempo? Posso adicionar noites à sua reserva, sujeito à disponibilidade.",
        },
        confirmationMessage: {
          label: "Mensagem de confirmação",
          placeholder: "Ótimo! Registrei as noites extras. Confirmaremos assim que o pagamento for concluído 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "sem custo",
      subjectToAvailability: " Sujeito à disponibilidade.",
    },
    default: "Olá! Como posso ajudar? 😊",
    knowledge: {
      guestWifi: "Qual é a senha do WiFi? 📶",
      wifiAnswer: "Claro! A rede WiFi é *{name}* e a senha é *{pass}*. Aproveite! 😊",
      wifiNameFallback: "da propriedade",
      wifiPassFallback: "••••••",
      genericAnswer: "Claro! Vou te enviar agora mesmo todas as informações que você precisa sobre a propriedade 😊",
    },
    checkin: {
      propFallback: "tu alojamiento",
      welcome: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{prop}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Elige tu idioma · Choose your language",
      langEs: "Español",
      langEn: "English",
      linkMsg: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "Claro! 😊 Você pode reservar diretamente aqui. Vou te enviar o link para escolher as suas datas:",
      whoAsk: "Com quem estou falando?",
      whoAnswer: "Olá! Sou o assistente de {biz} 😊 Como posso ajudar?",
      guestGreeting: "Olá! Vocês têm algo disponível neste fim de semana? 😊",
      howBook: "Ótimo, como faço para reservar?",
      linkLine: "{offer}\n\n🔗 Reserve aqui: {link}",
    },
    earlyAccess: {
      guestAsk: "Eu poderia fazer o check-in mais cedo? Chego por volta do meio-dia 🙏",
      tentativeReply: "Anotamos a sua chegada antecipada às 12:00. Faremos o possível para deixar tudo pronto, mas depende do checkout do hóspede anterior e da limpeza. Avisaremos assim que estiver disponível 🙏",
      confirmedReply: "Registramos a sua chegada antecipada às 12:00. Confirmaremos em breve 🙏",
    },
    lateCheckout: {
      courtesyPart: "Você tem {hours}h de cortesia grátis após {time}. ",
      costPart: "Fazer o checkout até {time} custa {price}{perHour}.",
      perHourSuffix: " por hora extra",
      payBoth: " Você pode pagar online ou em dinheiro no checkout.",
      payCash: " O pagamento é em dinheiro no checkout.",
      guestAsk: "Posso fazer o checkout mais tarde amanhã? 😅",
      guestConfirm: "OK, confirmo 👍",
      cashExtra: " (ou em dinheiro no checkout)",
      confirmPayDefault: "Pronto! Para confirmar, conclua o pagamento{extra}:",
      payLabel: "Pagar {price}",
      confirmCashDefault: "Pronto! Seu late checkout está confirmado. O pagamento de {price} é em dinheiro no checkout. 😊",
    },
    invoicing: {
      guestAsk: "Você pode me enviar a fatura? 🧾",
      linkMsg: "Olá! 👋\n\nAqui está o seu link para gerar e baixar a sua fatura eletrônica:\n{link}\n\nVocê pode voltar a este link sempre que precisar acessá-lo.",
      thanks: "Obrigado pela sua estadia! 🙌 Se você precisar da sua fatura, aqui está o link 👇",
      autoIssueNote: "_({hours}h depois, se não tiverem preenchido os seus dados)_\n\nEmitimos a sua fatura com os dados do seu check-in e a enviamos para você por e-mail. 📩",
      manualLinkMsg: "Olá! 👋\n\nAqui está o link para preencher os seus dados fiscais:\n{link}\n\nRevisaremos o seu pedido e emitiremos a fatura manualmente. 😊",
      manualRegistered: "Olá! 👋 Registrei o seu pedido de fatura. Vamos revisá-lo e emiti-lo manualmente o mais rápido possível. Obrigado! 😊",
    },
    extendStay: {
      guestAsk: "Posso ficar mais uma noite? 🌙",
      guestConfirm: "Sim, mais uma noite 👍",
      rateListing: "com a tarifa da sua reserva",
      ratePerNight: "por {price}/noite",
      nightSingular: "noite",
      nightPlural: "noites",
      offerDefault: "Claro! Posso adicionar até {max} {nights} {rate}.{avail}",
      cashExtra: " (ou em dinheiro)",
      confirmPayDefault: "Perfeito! Para confirmar a noite extra, conclua o pagamento{extra}:",
      payLabel: "Pagar a noite extra",
      confirmCashDefault: "Perfeito! Registrei a noite extra. O pagamento é em dinheiro e o anfitrião confirmará a extensão. 😊",
    },
    general: {
      guestAsk: "Olá! Com quem estou falando?",
      whoWithName: "Sou {name}, seu",
      whoNoName: "Sou seu",
      answer: "Olá! {who} assistente de recepção. Como posso ajudar?{emo}",
    },
  },
  nationalities: {
    auto: "Automático (com base no hóspede)",
    latam: "América Latina (neutro)",
    countries: {
      ES: "Espanha",
      MX: "México",
      CO: "Colômbia",
      AR: "Argentina",
      CL: "Chile",
      PE: "Peru",
      VE: "Venezuela",
      EC: "Equador",
      UY: "Uruguai",
      PY: "Paraguai",
      BO: "Bolívia",
      CR: "Costa Rica",
      PA: "Panamá",
      GT: "Guatemala",
      DO: "Rep. Dominicana",
      PR: "Porto Rico",
      CU: "Cuba",
      FR: "França",
      PT: "Portugal",
      BR: "Brasil",
      US: "Estados Unidos",
      IT: "Itália",
      BE: "Bélgica",
      MA: "Marrocos",
      NL: "Países Baixos",
      CH: "Suíça",
    },
    styles: {
      latamNeutral: "Latino-americano neutro",
      esES: "Padrão — informal (tú) · «vale», «genial»",
      esMX: "Padrão — «con gusto», «estacionamiento»",
      esCO: "Geral — formal (usted) · «con gusto»",
      esCOpaisa: "Paisa (Medellín) — «pues», «hágale»",
      esCOcosta: "Costeiro (Caribe) — «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá) — formal (usted) · «a la orden»",
      esCOvalle: "Valluno (Cali) — voseo · «vea pues»",
      esCOsantander: "Santander — direto · «de una»",
      esAR: "Voseo — «dale», «buenísimo»",
      esCL: "Caloroso — «estacionamiento»",
      esPE: "Formal (usted) — andino neutro",
      esVE: "Informal (tú) — «chévere»",
      esEC: "Formal (usted) — andino neutro",
      esUY: "Voseo — «ta», «bo»",
      esPY: "Voseo — caloroso",
      esBO: "Formal (usted) — andino",
      esCR: "Voseo — «pura vida»",
      esPA: "Informal (tú) — caribenho",
      esGT: "Formal (usted) — caloroso",
      esDO: "Informal (tú) — caribenho",
      esPR: "Informal (tú) — caribenho",
      esCU: "Informal (tú) — caribenho",
      frFR: "Francês (França)",
      ptPT: "Português (Portugal)",
      ptBR: "Português (Brasil)",
      enUS: "Inglês americano",
      itIT: "Italiano (Itália)",
      frBE: "Francês (Bélgica)",
      nlBE: "Holandês / Flamengo (Bélgica)",
      arMA: "Árabe (Marrocos)",
      frMA: "Francês (Marrocos)",
      nlNL: "Holandês",
      deCH: "Alemão suíço",
      frCH: "Francês suíço",
      itCH: "Italiano suíço",
    },
  },
};
